import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_cost_center'

const deleteCostCenter = async function(id) {
    try {
        let response = await axios.delete(route + '/' + id)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export { deleteCostCenter }
